import AuthService from '../../utilities/services/auth.service'
import { WeatherEventAnalyticsWrapper } from '../../components'

export default function WeatherEventAnalyticsPage() {
  const organization = AuthService.getOrg()[0]

  return <WeatherEventAnalyticsWrapper organization={organization} />
}
